import app from 'flarum/forum/app';
import Widget from 'flarum/extensions/afrux-forum-widgets-core/common/components/Widget';

export default class LastTweetWidget extends Widget {
    oncreate(vnode) {
        document.getElementById('zr01-html-widget-id').innerHTML = app.forum.attribute('zr-zr01-html-widget.customCode');
    }

    className() {
        return 'zr01-html-widget';
    }

    icon() {
        // Widget icon.
        return 'far fa-file-code';
    }

    content() {
        return <div class="zr01-html-widget" id="zr01-html-widget-id"></div>;
    }
}
